//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { generateComputed } from '../../../../common/functions/roles-computed-generator';
import Regiao from './Regiao';

export default {

  data() {
    return {
      regiaoResources: this.$api.regiao(this.$resource),
      bloquearBotaoExportacao: false,
      regioes: [],
      esperar: false,
      headers: [
        { text: this.$tc('label.cod_regiao', 1), value: 'cod_regiao' },
        { text: this.$tc('label.nome', 1), value: 'nom_regiao' },
        { text: this.$tc('label.ativo', 1), value: 'ind_ativo', sortable: true },
        { text: '', value: 'acoes', sortable: false },
      ],
      pagination: {},
      totalPage: 0,
      searchQuery: '',
      registros: [],
      selected: [],
    };
  },
  props: {
    title: String,
  },
  watch: {
    pagination: {
      handler() {
        this.filtrar();
      },
      deep: true,
    },
    searchQuery() {
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        this.filtrar();
      }, 500);
    },
  },
  computed: {
    filteredList() {
      return [];
    },
    ...generateComputed('Regiao', [
      'canAccessPage',
      'canAccessCRUD',
    ]),
    somenteLeitura() {
      return !this.canAccessCRUD;
    },
  },
  methods: {
    buscar() {
      if (this.searchQuery) {
        this.pagination.page = 1;
      }

      const params = {
        nome: this.searchQuery,
        page: this.pagination.page,
        size: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0],
      };

      this.regiaoResources.listar(params).then((response) => {
        this.registros = response.data.resposta;
        this.montarObjetoRegiao();
        this.totalPage = response.data.quantidadeRegistrosPagina;
        this.pararEsperar();
      }, (err) => {
        this.pararEsperar();
        this.$error(this, err);
      });
    },
    exportar() {
      this.bloquearBotaoExportacao = true;
      this.$emit('TABELA_EXPORTAR_DADOS',
        () => { this.bloquearBotaoExportacao = false; });
    },
    filtrar() {
      if (this.esperar) return;
      this.esperar = true;
      setTimeout(() => {
        this.buscar();
      }, 5E2);
    },
    getSearchQuery() {
      return this.searchQuery;
    },
    montarObjetoRegiao() {
      this.regioes = this.registros.map((data) => {
        const regiao = new Regiao();
        regiao.construirAPartirDaConsultaCompleta(data);
        return regiao;
      });
    },
    onEditarRegiao(regiao) {
      this.$emit('PESQUISA_REGIAO_EDITAR', regiao);
    },
    pararEsperar() {
      setTimeout(() => {
        this.esperar = false;
      }, 2E2);
    },
    mudarOrdenacao(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.regioes.slice();
    },
    limparSelecionados() {
      this.selected = [];
    },
    ativarInativarRegistros() {
      this.selected.forEach((item, idx) => {
        const resource = item.indAtivo ?
          this.regiaoResources.inativar :
          this.regiaoResources.ativar;

        const id = item.id;

        resource({ id }, { id })
          .then(() => {
            if ((idx + 1) === this.selected.length) {
              this.$toast.create(this.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
              this.limparSelecionados();
              this.filtrar();
            }
          })
          .catch((err) => {
            this.$error(this, err);
          });
      });
    },
  },
  mounted() {
    this.filtrar();
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/regiao/RegiaoTabela.vue?vue&type=script&lang=js&